import React from 'react'

export const createRadioButtonLabel = (StyledContainer, Heading, Body) => (labelTitle, labelBody) => (
  <StyledContainer>
    <Heading>{labelTitle}</Heading>
    <Body>{labelBody}</Body>
  </StyledContainer>
)
